module.exports = __webpack_public_path__ + "static/evn-logo-e1e4d2a72c2f97f008e3a881ef7f488b.png";